import { render, staticRenderFns } from "./tplBase.vue?vue&type=template&id=1a797e69&scoped=true&"
import script from "./tplBase.vue?vue&type=script&lang=js&"
export * from "./tplBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a797e69",
  null
  
)

export default component.exports